import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DashboardLayout } from "../components/dashboard/DashboardLayout";
import { MerchantsPanel } from "../components/dashboard/MerchantsPanel";
import { LeadsPanel } from "../components/dashboard/LeadsPanel";
import { StatsPanel } from "../components/dashboard/StatsPanel";
import { MarketingKitPanel } from "../components/dashboard/MarketingKitPanel";
import { ProfilePanel } from "../components/dashboard/ProfilePanel";
import { EmailPreviewPanel } from "../components/dashboard/EmailPreviewPanel";

export default function Licencie() {
  const { user, loading, logout } = useAuth();
  const [active, setActive] = useState("leads");

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "licencie") return <Navigate to="/" replace />;

  const sections = [
    { id: "leads",     label: "Leads",            content: <LeadsPanel /> },
    { id: "merchants", label: "Commerçants",      content: <MerchantsPanel canAssignLicencie={false} canDelete={false} /> },
    { id: "kit",       label: "Kit marketing",    content: <MarketingKitPanel /> },
    { id: "emails",    label: "Aperçu des emails", content: <EmailPreviewPanel /> },
    { id: "profile",   label: "Mon agence",       content: <ProfilePanel /> },
    { id: "stats",     label: "Statistiques",     content: <StatsPanel /> },
  ];

  return (
    <DashboardLayout
      user={user}
      sections={sections}
      active={active}
      onChange={setActive}
      onLogout={logout}
      subtitle={`Licencié · ${user.zone || "—"}`}
    />
  );
}
